// ABOUTME: Centralizes company-scoped feature visibility rules used by ATS surfaces.
// ABOUTME: Treats the existing MCP company flag as disabled unless it is explicitly true.

export const MCP_MENU_ITEMS = new Set(["mcpconnections"]);

export const MCP_AUTHORIZATION_FEATURES = new Set([
    "manageMcpConnections",
    "useMcp",
    "readMcpResumes",
    "exportMcpReports",
    "ManageMcpConnections",
    "UseMcp",
    "ReadMcpResumes",
    "ExportMcpReports"
]);

export const isMcpEnabledForCompany = (company?: { mcpEnabled?: boolean }) =>
    company?.mcpEnabled === true;

export const getVisibleMcpAuthorizationFeatures = <T extends { name?: string }>(
    features: T[],
    mcpEnabled?: boolean
) =>
    isMcpEnabledForCompany({ mcpEnabled })
        ? features
        : features.filter(
              (feature) => !MCP_AUTHORIZATION_FEATURES.has(feature.name || "")
          );
